import React from "react";
import PropTypes from "prop-types";
import Radio from "@mui/material/Radio";
import pixLogo from "../../../assets/pix.svg";
import styles from "./pixOption.module.css";

export default function PixOption({ selected, onSelect, whitelabel }) {
  return (
    <div
      className={styles.pixContainer}
      onClick={onSelect}
      style={{ cursor: "pointer" }}
    >
      <Radio
        checked={selected}
        onChange={onSelect}
        sx={{
          padding: "8px",
          "& .MuiSvgIcon-root": { fontSize: 22 },
          color: whitelabel?.theme?.text_primary_color || "#333",
          "&.Mui-checked": {
            color: whitelabel?.theme?.button_primary_color || "#0b3275",
          },
        }}
      />
      <img src={pixLogo} alt="Pix" className={styles.pixLogo} />
      <span
        className={`${styles.pixLabel} font-wl-500`}
        style={{ color: whitelabel?.theme?.text_primary_color }}
      >
        Pix
      </span>
      <span className={styles.approvalTag}>Aprovação em minutos</span>
    </div>
  );
}

PixOption.propTypes = {
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  whitelabel: PropTypes.object,
};
